import { React, useEffect, } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  createBoard,
  getBoard,
  resetState,
  updateBoard,
} from "../features/boards/boardSclice";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  post: yup.string().required("Post is Required"),
  email: yup.string().required("Email is Required"),
  phone: yup.string().required("Phone is Required"),
  location: yup.string().required("Location is Required"),
  image: yup.mixed().required("Image is Required"),
});
const AddNewscat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsCatId = location.pathname.split("/")[3];
  const newNewsCategory = useSelector((state) => state.board);
  const { isSuccess, isError, isLoading, createdBoard, updatedBoard, boardname, boardpost, boardemail, boardphone, boardlocation } = newNewsCategory;
  const token = useSelector((state) => state.autht.token);
  // const [imageErrorone, setImageErrorone] = useState("");

  useEffect(() => {
    if (getNewsCatId !== undefined) {
      dispatch(getBoard(getNewsCatId));
    } else {
      dispatch(resetState());
    }
  }, [dispatch, getNewsCatId]);
  useEffect(() => {
    if (isSuccess && createdBoard) {
      toast.success("Member Added Successfullly!");
      navigate("/association/Boards-list");
    }
    if (isSuccess && updatedBoard) {
      toast.success("Member Updated Successfullly!");
      navigate("/association/Boards-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, navigate, createdBoard, updatedBoard]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: boardname || "",
      post: boardpost || "",
      email: boardemail || "",
      phone: boardphone || "",
      location: boardlocation || "",
      image: null,
      token: token
    },
    validationSchema: schema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("post", values.post);
      formData.append("email", values.email);
      formData.append("phone", values.phone);
      formData.append("location", values.location);
      formData.append("image", values.image);
      formData.append("token", token);
      formData.append("id", getNewsCatId);
      console.log(formData);
      if (getNewsCatId !== undefined) {
        dispatch(updateBoard(formData));
        dispatch(resetState());
      } else {
        dispatch(createBoard(formData));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4  title">
        {getNewsCatId !== undefined ? "Edit" : "Add"} Board Member
      </h3>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="name"
            onChng={formik.handleChange("name")}
            onBlr={formik.handleBlur("name")}
            val={formik.values.name}
            label="Enter Name"
          />
          <div className="error">
            {formik.touched.name && formik.errors.name}
          </div>


          <CustomInput
            type="text"
            label="Enter Post"
            name="post"
            onChng={formik.handleChange("post")}
            onBlr={formik.handleBlur("post")}
            val={formik.values.post}
          />
          <div className="error">{formik.touched.post && formik.errors.post}</div>



          <CustomInput
            type="text"
            label="Enter Email"
            name="email"
            onChng={formik.handleChange("email")}
            onBlr={formik.handleBlur("email")}
            val={formik.values.email}
          />
          <div className="error">{formik.touched.email && formik.errors.email}</div>



          <CustomInput
            type="text"
            label="Enter Phone"
            name="phone"
            onChng={formik.handleChange("phone")}
            onBlr={formik.handleBlur("phone")}
            val={formik.values.phone}
          />
          <div className="error">{formik.touched.phone && formik.errors.phone}</div>


          <CustomInput
            type="text"
            label="Enter Location"
            name="country"
            onChng={formik.handleChange("location")}
            onBlr={formik.handleBlur("location")}
            val={formik.values.location}
          />
          <div className="error">{formik.touched.location && formik.errors.location}</div>


          <div className="mt-4">
            <label htmlFor="image" className="form-label">Select Image file</label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                formik.setFieldValue("image", e.currentTarget.files[0]);
                // setImageErrorone(""); // Clear image error when a new file is selected
              }}
              className="form-control"
            />
            <div className="error">{formik.touched.image && formik.errors.image}</div>
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
            disabled={isLoading}
          >
            {isLoading && (
              <div className="loader"></div>
            )}
            {isLoading ? "" : getNewsCatId !== undefined ? "Edit" : "Add"} Board Member
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewscat;
